/* eslint-disable no-restricted-globals,no-alert,object-curly-newline */
/* global G */
import { curry, PlatformEvent, setKey } from 'lib/util'
import sequenceComponentState from 'lib/sequence/component/state'
import publicSearch from 'app/_shared/events/search/public'
import find from 'lib/sequence/component/children/find'
import selectItem from 'app/registration/event/selectItem'

const {
  set: setError,
  unset: clearError,
} = sequenceComponentState('error')

const {
  set: setHelperText,
  unset: clearHelperText,
} = sequenceComponentState('helperText')

/**
 * Sets error state `hasError` for the item property of the request model attribute.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {boolean} hasError
 */
const setItemModelError = (module, hasError) => {
  const model = module[G.MODEL]
  const { request } = model[G.CHILDREN]
  const { item } = request[G.CHILDREN]
  item[G.STATE][G.ERROR] = hasError
  return true
}

/**
 * Returns the translated text to be displayed whenever a device is not found.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {*}
 */
const deviceNotFoundText = async (module) => {
  const _key = 'label.deviceNotFound'
  return await module[G.ADAPTER][G.INTL]._t(_key, {
    ns: 'device',
    _key,
    defaultValue: 'Device not found',
  })
}

const showResultsModal = async (module, serial) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { resultsModal, resultsList } = find(actionComponent)

  setKey(true, 'open', resultsModal[G.STATE])
  setKey({ term: serial }, G.META, resultsList[G.STATE])

  await module[G.ADAPTER][G.UI].update(module)
}

/**
 * Event Handler Search Device
 *
 * Attempts to find equipment by its serial and, depending on what is found, sets the current
 * model's item, equipment and product attributes with their information. Otherwise, if nothing is
 * found, those model attributes are cleared.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Gaia.PlatformEvent} event    the event object that triggered this handler
 * @returns {Promise<void>}
 */
const searchPublicEquipment = async (module, component, event) => {
  event.preventDefault()
  event.stopPropagation()

  const serial = event.detail.value?.trim()
  const required = component[G.VALIDATOR]
  // clearing field & model state
  clearError(component)
  clearHelperText(component)
  setItemModelError(module, false)

  if (serial) {
    const options = { term: `"${serial}"`, type: 'equipment' }
    const items = await publicSearch(null, module, component, options)

    if (!items.length) {
      setHelperText(component, await deviceNotFoundText(module))
      required
        && setItemModelError(module, true)
        && setError(component, true)

      await selectItem(module, component, null)

    } else if (items.length === 1) {
      const event = new PlatformEvent('search', { item: items[0] })

      await selectItem(module, component, event)

    } else {
      await showResultsModal(module, serial)
    }
  } else {
    await selectItem(module, component, null)
  }
}

export default curry(searchPublicEquipment)
